// extracted by mini-css-extract-plugin
export default {"categories-list":"CategoriesItemList_categories-list__MB8DG","thumb-dateils":"CategoriesItemList_thumb-dateils__AK2c-","dateils":"CategoriesItemList_dateils__tOlU1"};